export enum ListingDetailsTabNames {
    Comment = 'comment',
    Appointment = 'appointment'
}